import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

var IconButtonSize = {
  SM: "sm",
  MD: "md"
};
var IconButtonColor = {
  WHITE: "white",
  BLACK: "black",
  ACCENT: "accent",
  LIGHT: "light",
  TRANSPARENT: "transparent"
};

var _excluded = ["size", "icon", "disabled", "className", "color", "onClick", "mRef"];
var IconButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
    size = IconButtonSize.SM,
    icon = null,
    disabled = false,
    className = "",
    color = IconButtonColor.WHITE,
    onClick = () => {},
    mRef = null
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  var clsButtonSize = {
    [IconButtonSize.SM]: "h-8 w-8",
    [IconButtonSize.MD]: "h-10 w-10"
  };
  var clsIconSize = {
    [IconButtonSize.SM]: "h-4 w-4",
    [IconButtonSize.MD]: "h-5 w-5"
  };
  var clsButtonColor = {
    [IconButtonColor.WHITE]: disabled ? "bg-white dark:bg-midnight border dark:border-neutral-500" : "bg-white hover:bg-neutral-100 active:bg-neutral-200 dark:bg-midnight border dark:border-midnightborder",
    [IconButtonColor.BLACK]: disabled ? "bg-neutral-700" : "bg-neutral-700 hover:bg-neutral-800 active:bg-neutral-900",
    [IconButtonColor.ACCENT]: disabled ? "bg-accent-700" : "bg-accent-700 hover:bg-accent-800 active:bg-accent-900",
    [IconButtonColor.LIGHT]: disabled ? "bg-white" : "bg-neutral-100 hover:bg-neutral-200 active:bg-neutral-300 dark:border dark:bg-midnight dark:border-midnightborder",
    [IconButtonColor.TRANSPARENT]: "bg-transparent hover:bg-neutral-200 active:bg-neutral-300"
  };
  var clsIconColor = {
    [IconButtonColor.WHITE]: disabled ? "text-neutral-300 dark:text-neutral-600" : "text-neutral-600 dark:text-neutral-400",
    [IconButtonColor.BLACK]: "text-white",
    [IconButtonColor.ACCENT]: "text-white",
    [IconButtonColor.LIGHT]: disabled ? "text-neutral-300" : "text-neutral-600",
    [IconButtonColor.TRANSPARENT]: disabled ? "text-neutral-300" : "text-neutral-600"
  };
  return /*#__PURE__*/React.createElement("button", _extends({
    "data-testid": "IconButton",
    className: clsx("inline-flex shrink-0 items-center justify-center rounded-full", disabled ? "cursor-default" : "cursor-pointer", clsButtonColor[color], clsButtonSize[size], className),
    onClick: onClick,
    ref: mRef || ref
  }, rest), icon && /*#__PURE__*/React.createElement(icon, {
    className: clsx(clsIconSize[size], clsIconColor[color])
  }, null));
});
IconButton.propTypes = {
  size: PropTypes.oneOf(Object.values(IconButtonSize)),
  color: PropTypes.oneOf(Object.values(IconButtonColor)),
  icon: PropTypes.func,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  mRef: PropTypes.shape({
    current: PropTypes.any
  })
};
IconButton.displayName = "IconButton";

export { IconButton as I, IconButtonSize as a, IconButtonColor as b };
//# sourceMappingURL=IconButton-00c81cf5.js.map
